import { TransactionReceipt } from "thirdweb/dist/types/transaction/types";

export class BlockchainTransactionResult {
    public readonly status: boolean;
    public readonly transactionHash: string;

    public constructor(receipt: TransactionReceipt | null) {
        if (receipt) {
            this.status = receipt.status === 'success';
            this.transactionHash = receipt.transactionHash;
        }
    }
}
